import React, { useContext, useRef, useState } from 'react';
import { getAttributeNames } from 'gqlQueries/filterQueries';
import { queryPromise } from 'services/apolloInit';
import _ from 'lodash';
import { createChecklistObjectFromInitialCall } from 'parser/filterParser';
import { UserContext } from 'contexts/ConfigContext';
import { fetchScopeID, getConfig } from 'utils/helperMethods';

interface props {
    setAllCheckedAttribute: Function;
}

function useDownloadAllAttributeNames({ setAllCheckedAttribute }: props) {
    const [allAttributeName, setAllAttributeName] = useState({});
    const loadingRef = useRef(false);
    const { appConfig } = useContext(UserContext);
    const globalConfig = getConfig('globalFilter', appConfig);
    //to download all attribute names for the all the attribute type
    async function toCallAllAttribute(allDimAndAttributeType: any, filter = {}, defaultList = {}, allSelect = false) {
        try {
            let queryPromises: any = [];
            let overviewMetrics: any = {};
            if (allSelect) {
                loadingRef.current = true;

                let stringifyFilter = JSON.stringify(filter);
                let queryPromises = allDimAndAttributeType.map((attributeName: any) => {
                    return queryPromise(getAttributeNames, {
                        dimension: attributeName.dimensionReference,
                        isAttribute: attributeName.isAttribute,
                        attributeType: attributeName?.name,
                        searchKeyword: '',
                        limit: globalConfig.allSelectedLimit,
                        offset: 0,
                        filters: stringifyFilter,
                        rbacFilters: fetchScopeID(globalConfig.defaultIdObject),
                    });
                });

                Promise.all(queryPromises).then((responses) => {
                    responses.forEach((attributeType) => {
                        overviewMetrics[attributeType.data.getAttributeNames.data[0].attributeType] =
                            attributeType.data.getAttributeNames.data;
                    });
                });
            }
            createChecklistObjectFromInitialCall(overviewMetrics, setAllCheckedAttribute, defaultList, loadingRef);
        } catch (error) {
            console.error(error);
        }
    }

    return {
        loading: loadingRef.current,
        allAttributeName,
        functionTOCallAllAttributeName: (
            allDimAndAttributeType: any,
            filter = {},
            defaultList = {},
            allSelect = false,
        ) => {
            toCallAllAttribute(allDimAndAttributeType, filter, defaultList, allSelect);
        },
    };
}

export { useDownloadAllAttributeNames };
